var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-container",
    { staticClass: "d-flex ma-0 pa-0 d-md-none", attrs: { fluid: "" } },
    [
      _c(
        "v-layout",
        { staticClass: "ma-0 pa-0", attrs: { row: "", wrap: "" } },
        [
          _c(
            "v-col",
            { staticClass: "ma-0 pa-0", attrs: { cols: "12" } },
            [
              !_vm.hasProblem && _vm.isLoading
                ? _c(
                    "v-card",
                    { staticClass: "pa-3 text-center" },
                    [
                      _vm._v(
                        "\n                     Loading...\n                     "
                      ),
                      _c("v-progress-circular", {
                        attrs: { indeterminate: "", color: "lime" },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.hasProblem
                ? _c("v-card", { staticClass: "pa-3" }, [
                    _vm._v(
                      "\n                    Sorry, this content is not currently available\n                "
                    ),
                  ])
                : _vm._e(),
              _vm._v(" "),
              !_vm.allReservations.length && !_vm.hasProblem && !_vm.isLoading
                ? _c("v-card", [
                    _vm._v(
                      "\n                    There are no enquiries or reservations to display\n                "
                    ),
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm._l(_vm.allReservations, function (reservationGroup) {
                return !_vm.hasProblem && !_vm.isLoading
                  ? _c(
                      "v-card",
                      { attrs: { flat: "" } },
                      [
                        _c(
                          "v-container",
                          { attrs: { fluid: "" } },
                          [
                            _c(
                              "v-layout",
                              { attrs: { row: "", wrap: "" } },
                              [
                                _c("v-col", { attrs: { cols: "12" } }, [
                                  _c("h2", [
                                    _vm._v(
                                      _vm._s(reservationGroup.title) +
                                        " (" +
                                        _vm._s(
                                          reservationGroup.reservations.length
                                        ) +
                                        ")"
                                    ),
                                  ]),
                                  _vm._v(
                                    "\n                                " +
                                      _vm._s(reservationGroup.description) +
                                      "\n                            "
                                  ),
                                ]),
                                _vm._v(" "),
                                _vm._l(
                                  reservationGroup.reservations,
                                  function (reservation, index) {
                                    return _c(
                                      "v-card",
                                      { key: _vm.i },
                                      [
                                        _c(
                                          "v-card-text",
                                          { staticClass: "pa-3 ma-3" },
                                          [
                                            _c(
                                              "v-layout",
                                              { attrs: { row: "", wrap: "" } },
                                              [
                                                _c(
                                                  "v-col",
                                                  { attrs: { cols: "5" } },
                                                  [
                                                    _c("b", [
                                                      _vm._v("Reference:"),
                                                    ]),
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "v-col",
                                                  { attrs: { cols: "7" } },
                                                  [
                                                    reservation.responseIsOverdue
                                                      ? _c("span", {
                                                          staticClass:
                                                            "mr-1 circle-icon response-overdue d-none d-xl-block",
                                                        })
                                                      : _vm._e(),
                                                    _vm._v(" "),
                                                    _c(
                                                      "b",
                                                      {
                                                        staticStyle: {
                                                          "font-size": "100%",
                                                        },
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(
                                                            reservation.reference
                                                          )
                                                        ),
                                                      ]
                                                    ),
                                                    _vm._v(" "),
                                                    _c("a", {
                                                      attrs: {
                                                        name: reservation.reference,
                                                      },
                                                    }),
                                                    _vm._v(" "),
                                                    reservation.responseIsOverdue
                                                      ? _c("span", {
                                                          staticClass:
                                                            "circle-icon response-overdue",
                                                        })
                                                      : _vm._e(),
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                !_vm.hotelkey
                                                  ? _c(
                                                      "v-col",
                                                      { attrs: { cols: "5" } },
                                                      [
                                                        _c("b", [
                                                          _vm._v("Hotel:"),
                                                        ]),
                                                      ]
                                                    )
                                                  : _vm._e(),
                                                _vm._v(" "),
                                                !_vm.hotelkey
                                                  ? _c(
                                                      "v-col",
                                                      { attrs: { cols: "7" } },
                                                      [
                                                        _vm._v(
                                                          "\n                                                (" +
                                                            _vm._s(
                                                              reservation.hotel
                                                                .hotel_code
                                                            ) +
                                                            ") " +
                                                            _vm._s(
                                                              reservation.hotel
                                                                .hotel_name
                                                            ) +
                                                            "\n                                            "
                                                        ),
                                                      ]
                                                    )
                                                  : _vm._e(),
                                                _vm._v(" "),
                                                _c(
                                                  "v-col",
                                                  { attrs: { cols: "5" } },
                                                  [_c("b", [_vm._v("Dates:")])]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "v-col",
                                                  { attrs: { cols: "7" } },
                                                  [
                                                    _vm._v(
                                                      "\n                                                Arrive " +
                                                        _vm._s(
                                                          reservation.date_arrival
                                                        ) +
                                                        "\n                                                "
                                                    ),
                                                    _c("br"),
                                                    _vm._v(
                                                      "\n                                                Depart " +
                                                        _vm._s(
                                                          reservation.date_departure
                                                        ) +
                                                        "\n                                                "
                                                    ),
                                                    _c("br"),
                                                    _vm._v(
                                                      "\n                                                (" +
                                                        _vm._s(
                                                          reservation.num_nights
                                                        ) +
                                                        " nights)\n                                            "
                                                    ),
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "v-col",
                                                  { attrs: { cols: "5" } },
                                                  [_c("b", [_vm._v("Client:")])]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "v-col",
                                                  { attrs: { cols: "7" } },
                                                  [
                                                    _vm._v(
                                                      "\n                                                " +
                                                        _vm._s(
                                                          reservation.client
                                                            .first_name
                                                        ) +
                                                        " " +
                                                        _vm._s(
                                                          reservation.client
                                                            .last_name
                                                        ) +
                                                        "\n                                            "
                                                    ),
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "v-col",
                                                  { attrs: { cols: "5" } },
                                                  [
                                                    _c("b", [
                                                      _vm._v("Quote (GBP):"),
                                                    ]),
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "v-col",
                                                  { attrs: { cols: "7" } },
                                                  [
                                                    _vm._v(
                                                      "\n                                                " +
                                                        _vm._s(
                                                          reservation.quote_amount_gbp
                                                        ) +
                                                        "\n                                            "
                                                    ),
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "v-col",
                                                  {
                                                    staticClass: "align-center",
                                                    attrs: { cols: "12" },
                                                  },
                                                  [
                                                    reservation.has_voucher
                                                      ? _c(
                                                          "v-icon",
                                                          {
                                                            attrs: {
                                                              title:
                                                                "Gift vouchers were redeemed",
                                                            },
                                                          },
                                                          [
                                                            _vm._v(
                                                              "card_giftcard"
                                                            ),
                                                          ]
                                                        )
                                                      : _vm._e(),
                                                    _vm._v(" "),
                                                    reservation.has_van
                                                      ? _c(
                                                          "v-icon",
                                                          {
                                                            attrs: {
                                                              title:
                                                                "Virtual credit card created",
                                                            },
                                                          },
                                                          [
                                                            _vm._v(
                                                              "credit_card"
                                                            ),
                                                          ]
                                                        )
                                                      : _vm._e(),
                                                    _vm._v(" "),
                                                    reservation.is_prepaid
                                                      ? _c(
                                                          "v-icon",
                                                          {
                                                            attrs: {
                                                              title:
                                                                "Full advance payment made to i-escape",
                                                            },
                                                          },
                                                          [_vm._v("paid")]
                                                        )
                                                      : _vm._e(),
                                                    _vm._v(" "),
                                                    reservation.unreadMessages
                                                      ? _c(
                                                          "v-icon",
                                                          {
                                                            attrs: {
                                                              title:
                                                                "Has unread messages",
                                                            },
                                                          },
                                                          [
                                                            _vm._v(
                                                              "mark_chat_unread"
                                                            ),
                                                          ]
                                                        )
                                                      : _vm._e(),
                                                    _vm._v(" "),
                                                    reservation.is_instant
                                                      ? _c(
                                                          "v-icon",
                                                          {
                                                            attrs: {
                                                              title:
                                                                "Instant booking",
                                                            },
                                                          },
                                                          [_vm._v("bolt")]
                                                        )
                                                      : _vm._e(),
                                                    _vm._v(" "),
                                                    reservation.is_test
                                                      ? _c(
                                                          "v-icon",
                                                          {
                                                            attrs: {
                                                              title:
                                                                "Test booking",
                                                            },
                                                          },
                                                          [_vm._v("star")]
                                                        )
                                                      : _vm._e(),
                                                  ],
                                                  1
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "v-col",
                                                  { attrs: { cols: "12" } },
                                                  [
                                                    _c(
                                                      "v-btn",
                                                      {
                                                        staticClass:
                                                          "ies-green",
                                                        attrs: { block: "" },
                                                        on: {
                                                          click: function (
                                                            $event
                                                          ) {
                                                            return _vm.showReservation(
                                                              reservation.reservation_key
                                                            )
                                                          },
                                                        },
                                                      },
                                                      [_vm._v("Respond")]
                                                    ),
                                                  ],
                                                  1
                                                ),
                                              ],
                                              1
                                            ),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    )
                                  }
                                ),
                              ],
                              2
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    )
                  : _vm._e()
              }),
              _vm._v(" "),
              _vm.shouldDisplayReservation
                ? _c(
                    "v-col",
                    {
                      staticClass: "pa-0",
                      staticStyle: {
                        position: "fixed",
                        top: "0",
                        left: "0",
                        width: "100vw",
                        height: "100vh",
                        "max-width": "100vw",
                        "max-height": "100vh",
                        overflow: "auto",
                        "background-color": "white",
                        "z-index": "100",
                      },
                      attrs: { cols: "12" },
                    },
                    [
                      _c("v-btn", [_c("v-icon", [_vm._v("close")])], 1),
                      _vm._v(" "),
                      _c("ies-reservation-administration-management", {
                        attrs: { reservationkey: _vm.shouldDisplayReservation },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
            ],
            2
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }